<script lang="ts">
    import { _ } from 'svelte-i18n';

    import ErrorColor from '../../../shared/ErrorColor.svelte';
    import type { ImportAnalyzeContextItemType } from '../../ColumnSelectPro/ColumnSettingsApi';
    import ImportAnalyzeRowInfo from './ImportAnalyzeRowInfo.svelte';
    import InfoColor from '../../../shared/InfoColor.svelte';
    import WarningColor from '../../../shared/WarningColor.svelte';
    import ImportAnalyzeRowDetails from './ImportAnalyzeRowDetails.svelte';

    export let label: string;
    export let context: ImportAnalyzeContextItemType;
    export let comment: string = '';
    export let displayReasons: boolean = false;
    export let displayType: 'info' | 'problem' | 'warning' = 'info';

    let colorComponent = displayType === 'problem' ? ErrorColor : displayType === 'warning' ? WarningColor : InfoColor;
</script>

<div class="import-analyze-row-container">
    <div style="display: flex; flex-direction: row; column-gap: 10px; align-items: center;">
        <ImportAnalyzeRowInfo {label} count={context.count.toString()} />
        <slot></slot>
    </div>
    {#if context.reasons.length > 0 && displayReasons}
        <div class="import-analyze-row-reasons-container">
            <!--            <svelte:component this={colorComponent}>-->
            <div class="table">
                {#each context.reasons as reason, index}
                    <ImportAnalyzeRowDetails {reason} />
                {/each}
            </div>
            <!--            </svelte:component>-->
        </div>
    {/if}
</div>

<style>
    .import-analyze-row-container {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: flex-start;
        column-gap: 10px;
        width: 100%;
        padding: 5px 0;
    }

    .import-analyze-row-reasons-container {
        width: 100%;
        display: flex;
        max-height: 120px;
        overflow: auto;
        flex-direction: column;
        /*border-bottom: 1px solid gray;*/
    }

    .table {
        display: table;
        width: 100%;
    }
</style>
